import React, {useEffect, useState} from "react";
import { Modal, Form, Button, Col, Row } from "react-bootstrap";
import {DateTime} from "luxon";
import ApiService from "../../ApiService";

const CreateKitModal = ({data, isShowModal, onCloseCallBack, onSubmitCallback}) => {
    const [showModal, setShowModal] = useState(isShowModal ?? false);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        setShowModal(isShowModal ?? false);
    },[isShowModal, formData]);

    const handleShow = () => setShowModal(true);

    const handleClose = () => {
        setShowModal(false);
        onCloseCallBack();
        handleClear();
    }

    const handleClear = () => {
        setFormData({});
    };

    const handleFormValChange = (name, val) => {
        if(formData && formData[name] === val) return;
        const updatedFormData = {...formData, [name]: val};
        setFormData(updatedFormData);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        let err = [];
        if(!formData["panelName"]) err.push("panelName");
        if(!formData["labName"]) err.push("labName");
        if(!formData["sampleTakenDate"]) err.push("sampleTakenDate");
        if(!formData["medications"]) err.push("medications");
        if(!formData["notes"]) err.push("notes");
        if(formData["labName"] === 'LIFESCAN' && formData["lifescanReqNum"]?.length < 1){
            err.push("lifescanReqNum");
        }
        if (err.length > 0) {
            alert(`Missing required value for ${err.join(", ")}. Enter "none" if nothing to enter`);
            return;
        }
        const isSuccess = await onSubmitCallback(formData);
        if (!isSuccess) return;
        handleClose();
    };

    return (
        <>
            {formData && <Modal show={showModal} onHide={handleClose}>
                <Modal.Header>
                    <Modal.Title style={{textAlign: "left"}}>
                        Create Kit<br/>
                        <span style={{color: "blue", fontSize: 16}}>Assign the kit and populate results in Lab section</span>
                    </Modal.Title>
                    {/*<button type="button" className="btn-close" aria-label="Close" onClick={handleClose}>X</button>*/}
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row style={{paddingBottom: "10px"}}>
                            <Col xs={4}>Panel Name</Col>
                            <Col>
                                <Form.Group controlId="formPanel">
                                    <Form.Control 
                                        id="borderless"
                                        as="select"
                                        value={formData?.panelName ?? ''}
                                        onChange={e => handleFormValChange("panelName", e.target.value)}>
                                        <option value="">Select a panel</option>
                                        <option value="Custom Panel">Custom Panel</option>
                                        <option value="Performer Panel">Performer Panel</option>
                                        <option value="Polyamorous / Unsure Exposure Panel">Polyamorous / Unsure Exposure Panel</option>
                                        <option value="The VIP Panel">The VIP Panel</option>
                                        <option value="Check Me Out Panel">Check Me Out Panel</option>
                                        <option value="3 - Site Oral + Chlamydia">3 - Site Oral + Chlamydia</option>
                                        <option value="Bacterial Vaginosis">Bacterial Vaginosis</option>
                                        <option value="HPV">HPV</option>
                                        <option value="PASS Performer Panel">PASS Performer Panel</option>
                                        <option value="Mycoplasma genitalium">Mycoplasma genitalium</option>
                                        <option value="RUB Panel">RUB Panel</option>
                                        <option value="PASS/ Spankchain MGen Program">PASS/ Spankchain MGen Program</option>
                                    </Form.Control>

                                </Form.Group>
                            </Col>
                        </Row>
                        <Form.Group controlId="formLab">
                            <Row style={{paddingBottom: "10px"}}>
                                <Col xs={4}>Lab name</Col>
                                <Col>
                                    <Form.Control
                                        id="borderless"
                                        as="select"
                                        value={formData?.labName ?? ''}
                                        onChange={e => handleFormValChange("labName", e.target.value)}>
                                        <option value="">Select a lab</option>
                                        <option value="LIFESCAN">LIFESCAN</option>
                                        <option value="CDD">CDD</option>
                                        <option value="CLEAR">CLEAR</option>
                                    </Form.Control>
                                </Col>
                            </Row>
                        </Form.Group>

                        <hr/>
                        {formData?.labName === 'LIFESCAN' && <Form.Group controlId="LifescanReqNum">
                            <Row style={{paddingBottom: "10px"}}>
                            <Col xs={4}>Lifescan Requisition #</Col>
                            <Col>
                            <Form.Control
                                placeholder="Enter Lifescan Requisition #"
                                aria-label="Lifescan Order Requisition #"
                                as="textarea"
                                rows={1}
                                aria-describedby="basic-addon1"
                                value={formData?.lifescanReqNum ?? ''}
                                onChange={e => handleFormValChange("lifescanReqNum", e.target.value)}
                                readOnly={false}>
                            </Form.Control>
                            </Col>
                            </Row>
                        </Form.Group>}
                        <hr/>

                        <Form.Group controlId="formSampleTakenDate">
                            <Row style={{paddingBottom: "10px"}}>
                                <Col xs={4}>Sample taken date</Col>
                                <Col>
                                    <Form.Control
                                        id="borderless"
                                        type="date"
                                        defaultValue={data?.appntStart ? DateTime.fromISO(data?.appntStart).toFormat('LL-dd-yyyy') : null}
                                        placeholder="0"
                                        aria-label="Sample taken date"
                                        aria-describedby="basic-addon1"
                                        onChange={e => handleFormValChange("sampleTakenDate", e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </Form.Group>
                        <hr/>
                        <Form.Group controlId="Medications">
                            <Form.Label>Medications</Form.Label>
                            <Form.Control 
                                id="borderless"
                                as="textarea" 
                                rows={3} 
                                defaultValue={data?.medications}
                                value={formData?.medications ?? ''}
                                onChange={e => handleFormValChange("medications", e.target.value)} />
                        </Form.Group>
                        <hr/>
                        <Form.Group controlId="symptoms">
                            <Form.Label>Symptoms</Form.Label>
                            <Form.Control 
                                id="borderless"
                                as="textarea"
                                rows={3}
                                defaultValue={data?.symptoms}
                                value={formData?.symptoms ?? ''}
                                onChange={e => handleFormValChange("symptoms", e.target.value)} />
                        </Form.Group>
                        <hr/>
                        <Form.Group controlId="formNotes">
                            <Form.Label>Notes</Form.Label>
                            <Form.Control 
                                id="borderless"
                                as="textarea" 
                                rows={3} 
                                value={formData?.notes ?? ''}
                                onChange={e => handleFormValChange("notes", e.target.value)} />
                        </Form.Group>
                        <Modal.Footer>
                            <Button variant="light" onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button class="replyButton sendButton text-right" id="msg_reply"  type="submit">
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal.Body>
            </Modal>}
        </>
    );
};

export default CreateKitModal;
